import { createRoute } from '@tanstack/react-router'
import SettingsPage from '@/features/settings/pages/SettingsPage'
import { Route as authenticatedRoute } from './route'

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/settings',
  component: SettingsPage,
})
